import isMobile from '@anm/helpers/is/isMobile';
import { FC } from 'react';

import ExtraChargeAlert from './ExtraChargeAlert';
import UpgradeAlert from './UpgradeAlert';
import { IndicatorUsage, InfoText, LimitRowWrapper, LimitTitle, TitleWrapper, TrafficContent } from './Wrapper';
import { LimitRowProps } from './types';

const LimitRow: FC<LimitRowProps> = ({
  name,
  used,
  left,
  planName,
  isWarning,
  available,
  diffBytes,
  resetInTime,
  extraCharge,
  canPurchase,
  extraItemCost,
  isMonthLimit,
  leftInPercentage
}) => (
  <LimitRowWrapper>
    <TitleWrapper>
      <LimitTitle level={3} title={`${name[0].toUpperCase()}${name.slice(1)}`} />
      {resetInTime && <InfoText>Resets in {resetInTime}</InfoText>}
    </TitleWrapper>
    <TrafficContent>
      <InfoText>{`${used} of ${available} used`}</InfoText>
      {!isMobile() && <InfoText>{`${left} of ${available} left`}</InfoText>}
    </TrafficContent>
    <IndicatorUsage right={leftInPercentage} />
    {isWarning &&
      (canPurchase ? (
        <ExtraChargeAlert
          {...{
            name,
            left,
            used,
            isMonthLimit,
            planName,
            available,
            diffBytes,
            extraCharge,
            extraItemCost
          }}
        />
      ) : (
        <UpgradeAlert {...{ name }} />
      ))}
  </LimitRowWrapper>
);

export default LimitRow;
